import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components';
import { socialLinks } from '../../constants';

// Importing Link for navigation
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* 1st Footer Item - Brand About & Social Links */}
        <div className='footer-item'>

          <Logo variant="footer" />
          <p>AS Designs – Premium HTML & React website templates for modern businesses. Clean code, responsive design, and ready to launch.</p>

          {/* Social Media Icons */}
          <div className='social'>
            {socialLinks.map((social, index) => (
              <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" className='icon'>
                {social.icon}
              </a>
            ))}
          </div>

        </div>

        {/* 2nd Footer Item - Product Categories */}
        <div className='footer-item'>

          <h2>Categories</h2>

          <div className='info links'>
            <p><Link to='/Shop/category/landing%20pages'>Landing Pages</Link></p>
            <p><Link to='/Shop/category/HTML%20templates'>HTML Templates</Link></p>
            <p><Link to='/Shop/category/react%20templates'>React Templates</Link></p>
          </div>

        </div>

        {/* 3rd Footer Item - Quick Links */}
        <div className='footer-item'>

          <h2>Quick Links</h2>

          <div className='info links'>
            <p><Link to='/About-Us'>About Us</Link></p>
            <p><Link to='/Website-Templates'>Website Templates</Link></p>
            <p><Link to='/Services'>Services</Link></p>
            <p><Link to='/Blog-grid'>Blogs</Link></p>
            <p><Link to='/Contact-Us'>Contact Us</Link></p>
          </div>

        </div>

        {/* 4th Footer Item - Newsletter (As is) */}
        <div className='footer-item'>

          <h2>Newsletter</h2>
          <p>Subscribe to get updates on new templates, offers, and design tips.</p>

          <Newsletter variant='dark' idPrefix='2' />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; AS Designs 2026 All Rights Reserved</p>
        <p>
          <Link to='/Services-Terms'>Terms of Service</Link> | <Link to='/Refund-Policy'>Refund Policy</Link> | <Link to='/Privacy-Policy'>Privacy Policy</Link></p>

      </div>

    </footer>
  )
}

export default Footer;